const WooCommon = {
  init() {
    this.events();
    this.updateCart();
    this.quantity();
  },

  events() {
    $(".woocommerce-remove-coupon, [name=apply_coupon]").on("click", () => {
      $(".cart-page").addClass("loading");
    });
  },

  updateCart() {
    var timeout;

    $(".woocommerce").on("change", "input.qty", function () {
      if (timeout !== undefined) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        $(".cart-page").addClass("loading");
        $("[name='update_cart']").trigger("click");
      }, 1500);
    });
  },

  quantity() {
    const quantity = $(".quantity");
    if (quantity.length) {
      // Add
      $(".quantity__button--up").on("click", function () {
        const input = $(this).closest(".quantity").find("input");
        let current = parseInt(input.val());
        if (parseInt(input.attr("max")) > 0) {
          +input.attr("max") > current ? current++ : current;
        } else {
          current++;
        }
        input.val(current);
        input.change();
      });

      // Substract
      $(".quantity__button--down").on("click", function () {
        const input = $(this).closest(".quantity").find("input");
        let current = parseInt(input.val());
        +input.attr("min") < current ? current-- : current;
        input.val(current);
        input.change();
      });
    }
  },
};

export default WooCommon;
